var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_vm.getComponent(_vm.item.type),_vm._b({tag:"component",attrs:{"item":_vm.item}},'component',_vm.componentProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }